<h2 class="mt-5">{{cardConfiguration.title}}</h2>

<fieldset [disabled]="isWorkflowOnSubscriber">
<div class="row">
  <div class="col-sm-4">
    <div class="form-group">
      <label>
        {{'CardRemunerationsMilitary.MonthlyRevenue' | translate}}
        <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsMilitary.MonthlyRevenue' | translate}}"></span>
      </label>


      <div class="position-relative">
        <input class="form-control input-left" type="text" currency
               placeholder="{{'Placeholders.Generic.Currency' | translate}}"
               [(ngModel)]="cardData.monthlyRevenue" name="monthlyRevenue" #monthlyRevenue="ngModel" maxValue="999000" messageFieldType="currency">
        <span class="input-icon-span-left">€</span>
        <validation-message [control]="monthlyRevenue"></validation-message>
      </div>
    </div>
  </div>
  <div class="col-sm-4">
    <div class="form-group">

      <label>
        {{'CardRemunerationsMilitary.TimeToConsider' | translate}}
        <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsMilitary.TimeToConsider' | translate}}"></span>
      </label>
      <div class="form-row">
        <div class="col-sm-5">
          <input class="form-control" type="text" numeric="2" [(ngModel)]="cardData.numberOfYears" placeholder="aa" name="numberOfYears" #numberOfYears="ngModel">
          <validation-message [control]="numberOfYears"></validation-message>
        </div>
        <div class="col-sm-5">
          <input class="form-control" type="text" numeric="2" [(ngModel)]="cardData.numberOfMonths" placeholder="mm" maxValue="11" name="numberOfMonths" #numberOfMonths="ngModel">
          <validation-message [control]="numberOfMonths"></validation-message>
        </div>
      </div>
    </div>
  </div>
</div>
</fieldset>

<!--<pre>{{cardData | json}}</pre>-->
